import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Heading from "../Heading/Heading";
import SkillProgress from "../SkillProgress/SkillProgress";

const Skills = () => {
  return (
    <section id="skill" className="mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Heading title1="My Skills" title2="Let's See My Skills" />
          </div>

          <div className="col-lg-12">
            <div className="skill-tab text-center mt-4 mb-5">
              <Tabs
                defaultActiveKey="web"
                id="uncontrolled-tab-example"
                className="mb-3"
                justify
              >
                <Tab eventKey="web" className="bold" title="Web">
                  <div className="row">
                    <div className="col-lg-6">
                      <SkillProgress name="HTML" count="90%" progress="90" />
                      <SkillProgress name="CSS" count="88%" progress="88" />
                      <SkillProgress
                        name="JAVASCRIPT"
                        count="78%"
                        progress="78"
                      />
                      <SkillProgress name="REACT" count="80%" progress="80" />
                      <SkillProgress name="NEXTJS" count="50%" progress="50" />
                      <SkillProgress name="MONGODB" count="80%" progress="80" />
                    </div>

                    <div className="col-lg-6">
                      <SkillProgress
                        name="EXPRESSJS"
                        count="85%"
                        progress="85"
                      />
                      <SkillProgress name="NODEJS" count="75%" progress="75" />
                      <SkillProgress
                        name="BOOTSTRAP"
                        count="90%"
                        progress="90"
                      />
                      <SkillProgress
                        name="TAILWIND"
                        count="80%"
                        progress="80"
                      />
                      <SkillProgress name="MUI" count="80%" progress="80" />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Others" title="Others">
                  <div className="row">
                    <div className="col-lg-6">
                      <SkillProgress
                        name="REACT NATIVE"
                        count="60%"
                        progress="60"
                      />
                    </div>
                    <div className="col-lg-6">
                      <SkillProgress name="REDUX" count="60%" progress="60" />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Programming" title="Programming">
                  <div className="row">
                    <div className="col-lg-6">
                      <SkillProgress
                        name="JAVASCRIPT"
                        count="60%"
                        progress="60"
                      />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Tools" title="Tools">
                  <div className="row">
                    <div className="col-lg-6">
                      <SkillProgress name="GIT" count="70%" progress="70" />
                      <SkillProgress name="FIGMA" count="68%" progress="68" />
                    </div>
                    <div className="col-lg-6">
                      <SkillProgress
                        name="PHOTOSHOP"
                        count="60%"
                        progress="60"
                      />
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
